import { STATUS_TYPE } from '../../../enum';

export interface GetAddOnCategory {
  id: string;
}

export interface FindAddOnCategory {
  search?: string;
}

export interface CreatePatchAddOnCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  emoji: string;
  previewUrl: string;
  position: string;
  activeState: boolean;
}

export interface AddOnCategory {
  id: string;
  labelEn: string;
  labelAr: string;
  emoji: string;
  previewUrl: string;
  position: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: AddOnCategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
